@if (!currReport) {
<div>
  <h1 class="report-title">Report : Integration Bulk Action Report</h1>
  @if(pageLoading){
  <div>
    <app-lt-spinner></app-lt-spinner>
  </div>
  }
</div>
} @else {
<div>
  <h1 class="report-title">
    Report <span>: {{ currReport.title }}</span>
  </h1>
  <hr class="hr-solid" />
  <!-- Action Buttons -->
  <ng-container>
    <div class="match-form-field title-center mb-3">
      <mat-button-toggle-group #group="matButtonToggleGroup" [multiple]="false" [hideSingleSelectionIndicator]="true"
        (change)="onToggleActionChange($event.value)">
        <mat-button-toggle [checked]="bulkActionType === bulkIntegActionType.LockUnlock" value="LockUnlock"
          aria-label="Lock Unlock">
          Lock / Unlock Integrations
        </mat-button-toggle>
        <mat-button-toggle [checked]="bulkActionType === bulkIntegActionType.MoveServerIntegrations"
          value="MoveServerIntegrations" aria-label="Move Server Integrations">
          Move Server Integrations
        </mat-button-toggle>
        <mat-button-toggle [checked]="bulkActionType === bulkIntegActionType.UpdateRunTimes" value="UpdateRunTimes"
          aria-label="Update RunTimes">
          Update RunTimes
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </ng-container>
  @if (bulkActionSelected) {
  <!-- Action Area -->
  @if (bulkActionType === bulkIntegActionType.LockUnlock) {
  <div class="report-switch">
    <div class="btn-group btn-group-lg btn-group-toggle" role="group" aria-label="Lock Group" data-toggle="buttons">
      <input type="radio" class="btn-check" id="report-switch-locked" [value]="false" [ngModel]="!switchLocked"
        (ngModelChange)="switchLocked = $event" data-ng-model="!switchLocked" (click)="onLockSwitchChange()" />
      <label class="btn" for="report-switch-locked" [ngClass]="{
                'btn-danger': !switchLocked,
                'btn-secondary': switchLocked
              }">
        Locked
      </label>
      <input type="radio" class="btn-check" id="report-switch-unlocked" [value]="true" [(ngModel)]="switchLocked"
        data-ng-model="switchLocked" (click)="onLockSwitchChange()" />
      <label class="btn" for="report-switch-unlocked" [ngClass]="{
                'btn-secondary': !switchLocked,
                'btn-success': switchLocked
              }">
        Unlocked
      </label>
    </div>
  </div>
  }
  @if (bulkActionType === bulkIntegActionType.MoveServerIntegrations) {
  <div class="report-switch">
    <div class="d-flex flex-row justify-content-center align-items-center align-self-center gap-3">
      <div>
        <mat-form-field appearance="fill" class="example-full-width">
          <mat-label>Select a server</mat-label>
          <mat-select [(value)]="selectedServer" (selectionChange)="changeServer($event)">
            @for (server of serverItems; track server) {
            <mat-option [value]="server">
              {{ server.description }} - Count: {{ server.integrationCount }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="pb-3">
        <button matButton="elevated" (click)="openServerInfoDialog()" class="px-2">
          <mat-icon class="material-icons-outlined">help_outline</mat-icon>
          See Server Information
        </button>
      </div>
    </div>
  </div>
  }
  @if (bulkActionType === bulkIntegActionType.UpdateRunTimes) {
  <div class="mt-2 mb-2">
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>RunTime Update Fields</mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="runTimeUpdateFormGroup" role="group">
          <div class="report-switch">
            <div class="report-filter-cards">
              <div class="row row-cols-2 row-cols-md-2 row-cols-sm-2 g-4 pb-1">
                <div class="col">
                  <div class="card h-100">
                    <div class="card-header d-flex justify-content-between">
                      <div class="align-self-center">LastRunTime</div>
                      <mat-checkbox [checked]="enableLastRunTime"
                        (change)="changeEnableRunTimeChecks('LAST', $event.checked)" labelPosition="before">
                        Enable
                      </mat-checkbox>
                    </div>
                    <div class="card-body">
                      <div class="card-title"></div>
                      <div class="example-wrapper">
                        <app-lt-datetimepicker formControlName="lastDate" [required]="enableLastRunTime"
                          [disabled]="!enableLastRunTime" format="MM/dd/yyyy hh:mm:ss a"></app-lt-datetimepicker>
                        @if((runTimeUpdateFormGroup.get('lastDate').touched ||
                        runTimeUpdateFormGroup.get('lastDate').dirty)
                        && enableLastRunTime && runTimeUpdateFormGroup.get('lastDate')?.errors?.required){
                        <app-lt-form-error message="Date is required if enabled."></app-lt-form-error>
                        }
                        @if(lastDateFormControl.valid && enableLastRunTime && nextDateFormControl.valid
                        && enableNextRunTime && lastDateFormControl.value > nextDateFormControl.value){
                        <app-lt-form-error
                          message="Last Run Time Date must before or equal to the Next Run Time Date if both are enabled."></app-lt-form-error>
                        }
                        @if(!enableLastRunTime && !enableNextRunTime) {
                        <app-lt-form-error
                          message="One of LastRunTime or NextRunTime Dates must be enabled."></app-lt-form-error>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card h-100">
                    <div class="card-header d-flex justify-content-between">
                      <div class="align-self-center">NextRunTime</div>
                      <mat-checkbox [checked]="enableNextRunTime"
                        (change)="changeEnableRunTimeChecks('NEXT', $event.checked)" labelPosition="before">
                        Enable
                      </mat-checkbox>
                    </div>
                    <div class="card-body text-center">
                      <div class="example-wrapper">
                        <app-lt-datetimepicker formControlName="nextDate" [required]="enableNextRunTime"
                          [disabled]="!enableNextRunTime" format="MM/dd/yyyy hh:mm:ss a"></app-lt-datetimepicker>
                        @if ((runTimeUpdateFormGroup.get('nextDate').touched ||
                        runTimeUpdateFormGroup.get('nextDate').dirty)
                        && enableNextRunTime && runTimeUpdateFormGroup.get('nextDate')?.errors?.required){
                        <app-lt-form-error message="Date is required if enabled."></app-lt-form-error>
                        }
                        @if (!enableLastRunTime && !enableNextRunTime) {
                        <app-lt-form-error
                          message="One of LastRunTime or NextRunTime Dates must be enabled."></app-lt-form-error>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card h-100">
                    <div class="card-header">
                      <div>Destination Endpoint for Integration RunTimes</div>
                    </div>
                    <div class="card-body">
                      <div class="example-wrapper">
                        <mat-form-field>
                          <mat-label>Destination Endpoints</mat-label>
                          <mat-select [formControl]="destinationsControl" name="destinationEndpoints" required multiple
                            disableOptionCentering panelClass="rTPanelClass">
                            <mat-select-trigger>
                              <mat-chip-set>
                                @for (x of destinationsControl.value; track x) {
                                <mat-chip [removable]="true" (removed)="onRTSelectionRemoved('DESTINATION', x)">
                                  {{ x.displayName }}
                                  <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                                }
                              </mat-chip-set>
                            </mat-select-trigger>
                            @for (x of destinationEndpointItems; track x) {
                            <mat-option [value]="x">{{ x.displayName }}</mat-option>
                            }
                          </mat-select>
                          @if (destinationsControl.hasError('required')) {
                          <mat-error>Must have at least one selected.</mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card h-100">
                    <div class="card-header">
                      <div>Import Types for Integration RunTimes</div>
                    </div>
                    <div class="card-body">
                      <div class="example-wrapper">
                        <mat-form-field>
                          <mat-label>Import Types</mat-label>
                          <mat-select [formControl]="importTypesControl" name="importTypes" required multiple
                            disableOptionCentering panelClass="rTPanelClass">
                            <mat-select-trigger>
                              <mat-chip-set>
                                @for (x of importTypesControl.value; track x) {
                                <mat-chip [removable]="true" (removed)="onRTSelectionRemoved('IMPORTTYPE', x)">
                                  {{ x.typeDescription }}
                                  <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                                }
                              </mat-chip-set>
                            </mat-select-trigger>
                            @for (i of importTypeItems; track i) {
                            <mat-option [value]="i">{{ i.typeDescription }}</mat-option>
                            }
                          </mat-select>
                          @if (importTypesControl.hasError('required')) {
                          <mat-error>Must have at least one selected.</mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  }

  <!-- filter cards -->
  <div class="report-filter-cards">
    <div class="row row-cols-1 row-cols-md-4 row-cols-sm-3 g-4 pb-1">
      <div class="col">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">DataSource Type:</div>
            <div class="example-wrapper">
              <app-lt-multiselect-t [data]="dataSourceTypeItems" textField="description" valueField="dataSourceTypeId"
                placeholder="Select Data Source Type..." (selectionChange)="externalFilterChange()"
                [(ngModel)]="dataSourceItemsSelected"></app-lt-multiselect-t>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Destination Endpoints</div>
            <div class="example-wrapper">
              <app-lt-multiselect-t [data]="destinationEndpointItems" textField="displayName"
                valueField="destinationEndpointId" placeholder="Select Destination Endpoint..."
                (selectionChange)="externalFilterChange()"
                [(ngModel)]="destinationEndpointItemsSelected"></app-lt-multiselect-t>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Import Type (RunTime V2)</div>
            <div class="example-wrapper">
              <app-lt-multiselect-t [data]="importTypeItems" textField="typeDescription" valueField="importTypeId"
                placeholder="Select Import Type..." (selectionChange)="externalFilterChange()"
                [(ngModel)]="importTypeItemsSelected"></app-lt-multiselect-t>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Server:</div>
            <div class="example-wrapper">
              <app-lt-multiselect-t [data]="serverItems" textField="description" valueField="serverId"
                placeholder="Select Server..." (selectionChange)="externalFilterChange()"
                [(ngModel)]="serverItemsSelected"></app-lt-multiselect-t>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="report-command-button-group">
    <button class="btn btn-outline-secondary" (click)="resetFilters($event)">
      Reset Filters
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="applyFilters()">
      Apply Filters
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="unSelectAll($event)"
      [disabled]="selectedIds.length === 0">
      Deselect All
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="selectAll()">
      Select All
    </button>
    @if (bulkActionType === bulkIntegActionType.LockUnlock) {
    <app-integration-lock (lockReasonSubmitted)="lockIntegrations($event)" [locked]="!switchLocked"
      [disabled]="selectedIds.length === 0" #lockReason>
    </app-integration-lock>
    }
    @if (bulkActionType === bulkIntegActionType.MoveServerIntegrations) {
    <button type="button" class="btn btn-outline-secondary" (click)="moveIntegrations($event)"
      [disabled]="selectedIds.length === 0">
      Move Selected Server Integrations
    </button>
    }
    @if (bulkActionType === bulkIntegActionType.UpdateRunTimes) {
    <button type="button" class="btn btn-primary lts-btn-primary" (click)="updateIntegrationRunTimes($event)"
      [disabled]="selectedIds.length === 0">
      Update RunTimes
    </button>
    }
  </div>
  <hr class="hr-solid" />
  <div class="report-grid-wrapper">
    @if (bulkActionType === bulkIntegActionType.UpdateRunTimes) {
    <div>
      <h5 class="report-title important-red-text">
        Warning: Integration RunTimes may not get updated if integration is
        currently running.
      </h5>
    </div>
    }
    <ng-container>
      <div class="m-1">
        <div class="report-grid-wrapper">
          <app-lt-png-table #integrationGrid [gridSettingsInput]="integrationGridSettings()" [showToolbarInput]="false"
            (selectionChange)="selectionChangeHandler()">
            <ng-template appGridTemplate="expandedrow" let-data let-rowIndex="rowIndex ">
              <section>
                <div>
                  <app-lt-generic-grid-wrapper [data]="data.integrationRunTimes" [columns]="runtimeCols"
                    [isResizeable]="false" [isSelectable]="false" [showExportToolbar]="false"
                    [loading]="gettingRunTimes">
                  </app-lt-generic-grid-wrapper>
                </div>
              </section>
            </ng-template>
          </app-lt-png-table>
        </div>
      </div>
    </ng-container>
  </div>
  }
</div>
}

<!-- Report Back Button -->
<ng-container>
  <div class="report-command-button-group">
    <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
      Go Back
    </button>
  </div>
</ng-container>

<ng-template #serverInfoDialog>
  <h2 matDialogTitle>Server Information</h2>
  <mat-dialog-content>
    <div>
      <app-lt-generic-grid-wrapper [data]="serverItems" [columns]="serverInfoCols" [isResizeable]="true"
        [isSelectable]="false" [showExportToolbar]="false" [loading]="gettingServerItems">
      </app-lt-generic-grid-wrapper>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton matDialogClose color="primary">Close</button>
  </mat-dialog-actions>
</ng-template>